import { Observable } from 'rxjs/Rx'
import { Injectable } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, } from '@angular/router'

import { ResourceService } from '@mprep/shared/data/services'
import { ResourceType } from '@mprep/shared/data/models'

import { NavigationService } from 'app/shared/services'

const VIDEO_RESOURCE_TYPES = [
  ResourceType.Video,
  ResourceType.Brightcove,
]

@Injectable()
export class ResourceVideoGuard implements CanActivate {

  constructor(
    private _resourceService: ResourceService,
    private _navigationService: NavigationService
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._resourceService.findModelById(route.params.id).map((resource) => {
      if (VIDEO_RESOURCE_TYPES.includes(resource.resourceType)) {
        return true
      }
      this._navigationService.navigateToResource(resource)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/resource-video-guard/resource-video-guard.ts